// eslint-disable-next-line
import React, { useEffect } from "react";

function configHyphenopoly(onReady) {
  window.Hyphenopoly.config({
    require: {
      sv: "nordvästersjökustartilleriflygspaningssimulatoranläggningsmaterielunderhållsuppföljningssystemdiskussionsinläggsförberedelsearbete",
      en: "Supercalifragilisticexpialidocious",
    },
    handleEvent: {
      hyphenopolyEnd: onReady,
      tearDown: onReady,
    },
    setup: {
      selectors: {
        ".Profile": {},
      },
    },
  });
}

/**
 * Injects Hyphenopoly into the DOM so that hyphenation can be used in the headless chrome instance in AWS Lambda.
 */
export function Hyphenopoly({ onReady = () => {} }) {
  useEffect(() => {
    const script = document.createElement("script");
    script.id = "hyphenopoly-script-loader";
    script.type = "text/javascript";
    script.src = "/hyphenopoly/Hyphenopoly_Loader.min.js";
    script.onload = () => configHyphenopoly(onReady);
    document.body.appendChild(script);
  }, []);

  return null;
}
